import React from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './ConfirmationPage.module.css';
import { FaCheck } from 'react-icons/fa';

const ConfirmationPage = () => {
    const navigate = useNavigate();

    return (
        <div className={classes.page_wrapper}>
            {/* Background blobs */}
            <div className={classes.bg_blob_1}></div>
            <div className={classes.bg_blob_2}></div>

            <div className={classes.card}>
                {/* Logo */}
                <div className={classes.logo_area}>
                    <div className={classes.logo_icon_wrap}>
                        <img
                            src="/assets/images/logo.png"
                            alt="GamePlex logo"
                            className={classes.logo_icon}
                        />
                    </div>
                    <p className={classes.logo_text}>
                        Game<span>Plex</span>
                    </p>
                </div>

                {/* Animated success icon */}
                <div className={classes.success_icon_wrap}>
                    <FaCheck className={classes.success_icon} />
                </div>

                {/* Text */}
                <div className={classes.content_area}>
                    <h1 className={classes.title}>Thank you for subscribing</h1>
                    <p className={classes.subtitle}>
                        Your account is now active. Enjoy our services.
                    </p>
                </div>

                {/* CTA */}
                <button
                    type="button"
                    className={classes.cta_btn}
                    onClick={() => navigate('/')}
                >
                    Continue to Home
                </button>

                {/* Support */}
                <p className={classes.support_row}>
                    Need help?{' '}
                    <span className={classes.support_link}>Contact Support</span>
                </p>
            </div>
        </div>
    );
};

export default ConfirmationPage;
